import log from 'loglevel';

// Set the default log level (options: trace, debug, info, warn, error, silent)
log.setLevel('debug'); // Change this to 'info' or 'error' for less verbose logging

export default log; 